import { useState, useEffect } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Table,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/personPlaceholder.png";
import { get, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { Avatar } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import search from "../../../assets/images/Search.png";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const MyClubGyms = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [gymsData, setGymsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 6;
  const { currentUser } = useSelector((state) => state.auth);
  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );
  const toggleDropdown = (gymId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [gymId]: !prevState[gymId],
    }));
  };

  const fetchGyms = async (page) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.gym}/admin?limit=${itemsPerPage}&page=${page}&userId=${currentUser.id}`
      );
      setGymsData(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching gyms data:", error);
      setGymsData([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGyms(currentPage);
  }, [currentPage]);

  const navigate = useNavigate();
  const handleSelectChange = async (action, gymId) => {
    if (action === "add") {
      navigate(`/add-passes?gymId=${gymId}`);
    } else if (action === "passList") {
      navigate(`/list-passes?gymId=${gymId}`);
    } else if (action === "addEquip") {
      navigate(`/add-equip?gymId=${gymId}`);
    } else if (action === "equipList") {
      navigate(`/equip-listing?gymId=${gymId}`);
    } else if (action === "modify") {
      navigate(`/edit-gyms/${gymId}`, { state: { gymId: gymId } });
    } else if (action === "gymDetails") {
      navigate(`/gym-details/:id`, { state: { gymId: gymId } });
    } else if (action === "delete") {
      console.log("Deleting gym with ID:", gymId);
      try {
        await del(`${endpoints.gym}/${gymId}`);
        setGymsData((prevData) => prevData.filter((gym) => gym._id !== gymId));
        toast.success("Gym Deleted Successfully", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        fetchGyms(currentPage);
      } catch (error) {
        console.error("Error Deleting Gym:", error);
        alert("Failed to delete the gym.");
      }
    }
  };

  return (
    <Card className="rounded-4 mb-2">
      <CardBody className="overflow-scroll">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="ff-sora font-size-16 fw-normal primary-black">
            My Clubs/Gyms
          </span>
          <Link
            to="/list-gyms"
            className="ff-sora font-size-16 fw-bold secondary-black"
          >
            View All
          </Link>
        </div>

        <div
          className="table-responsive hide-scrollbar rounded-4"
          style={{ minHeight: "450px" }}
        >
          {loading ? (
            <tr>
              <td colSpan={8} className="text-center">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="spinner-border"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      color: "#3BABA6",
                    }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          ) : error ? (
            <Alert
              color="danger"
              className="text-center ff-sora font-size-14 secondary-black fw-normal"
            >
              {error}
            </Alert>
          ) : gymsData.length === 0 ? (
            <>
              <tr>
                <td
                  colSpan="8"
                  className="text-center ff-sora font-size-16 fw-normal"
                >
                  <img
                    src={Placeholder}
                    alt={`logo`}
                    className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="8"
                  className="text-center border-0 ff-sora font-size-16 fw-normal"
                >
                  No Record Found!
                </td>
              </tr>
            </>
          ) : (
            <Table className="table-borderless table-centered table-nowrap">
              <thead>
                <tr
                  className="ff-sora font-size-14 fw-bold primary-black"
                  style={{ lineHeight: "16.8px" }}
                >
                  <th>Id</th>
                  <th>Gym/Club</th>
                  <th>Location</th>
                  <th>Registered On</th>
                  <th>Visit By</th>
                  <th>Loved By</th>
                  <th>Saved By</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {gymsData.slice(0, itemsPerPage).map((gym, index) => (
                  <tr
                    key={gym._id + index}
                    className="ff-sora font-size-14 secondary-black"
                    style={{ lineHeight: "16.8px", fontWeight: "400" }}
                  >
                    <td>{index + 1}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            gym?.logo?.data == null
                              ? avatar
                              : `${process.env.REACT_APP_IMG_URL}${gym?.logo?.data}`
                          }
                          alt={`${gym.name} logo`}
                          className="object-fit-contain rounded-3 me-2"
                          width={"32px"}
                          height={"32px"}
                        />
                        <div>
                          <h6
                            className="ff-sora font-size-14 secondary-black"
                            style={{
                              lineHeight: "16.8px",
                              fontWeight: "400",
                            }}
                          >
                            {gym.name}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      {gym.address || gym.location?.formatted_address || "N/A"}
                    </td>
                    <td>
                      {gym.createdAt
                        ? new Date(gym.createdAt.$date).toLocaleDateString()
                        : "N/A"}
                    </td>

                    <td>{gym.visitBy || "0"} People</td>
                    <td>{gym.lovedBy || "0"} People</td>
                    <td>{gym.savedBy || "0"} People</td>
                    <td>
                      <Dropdown
                        isOpen={dropdownOpen[gym._id]}
                        toggle={() => toggleDropdown(gym._id)}
                        direction="down"
                      >
                        <DropdownToggle
                          tag="button"
                          className="btn btn-link p-0"
                          style={{
                            width: "30px",
                            height: "30px",
                          }}
                        >
                          <img src={moreIcon} alt="More options" />
                        </DropdownToggle>
                        <DropdownMenu end>
                          {userPermissions?.passes?.["Create Pass"] && (
                            <DropdownItem
                              onClick={() => handleSelectChange("add", gym._id)}
                            >
                              Add Pass
                            </DropdownItem>
                          )}
                          {userPermissions?.equipment?.["Create Equipment"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("addEquip", gym._id)
                              }
                            >
                              Add Equipment
                            </DropdownItem>
                          )}
                          {userPermissions?.equipment?.["View Equipment"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("equipList", gym._id)
                              }
                            >
                              List Equipment
                            </DropdownItem>
                          )}
                          {userPermissions?.passes?.["View Pass"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("passList", gym._id)
                              }
                            >
                              Pass List
                            </DropdownItem>
                          )}
                          {userPermissions?.gym?.["Update Gym"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("modify", gym._id)
                              }
                            >
                              Edit Gym
                            </DropdownItem>
                          )}
                          {userPermissions?.gym?.["View Gym"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("gymDetails", gym._id)
                              }
                            >
                              Gym Details
                            </DropdownItem>
                          )}
                          {userPermissions?.gym?.["Delete Gym"] && (
                            <DropdownItem
                              onClick={() =>
                                handleSelectChange("delete", gym._id)
                              }
                            >
                              Delete Gym
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default MyClubGyms;
